import React, { useMemo } from "react";
import _ from "underscore";
import SampleTestsForTechnique from "./SampleTestsForTechnique";
import { useTests } from "./contexts/ResultsContext";

export default function Sample({
  sample,
  selectedSampleTestIds,
  clientView = true,
  viewSingleSample,
  simpleSampleView
}) {
  const tests = useTests();
  const testsByTechnique = useMemo(
    () => _.groupBy(sample.sample_tests, st => tests[st.test_id].technique_id),
    [sample.sample_tests]
  );
  return Object.keys(testsByTechnique).map((technique_id, index) => (
    <SampleTestsForTechnique
      key={technique_id}
      clientView={clientView}
      sample={sample}
      sampleTests={testsByTechnique[technique_id]}
      showSample={index == 0}
      selectedSampleTestIds={selectedSampleTestIds}
      viewSingleSample={viewSingleSample}
      simpleSampleView={simpleSampleView}
    />
  ));
}
